import client from '../../../vendor/rshop/frontend/assets/js/common/client'
import { CancelToken } from 'axios'

const lang = document.querySelector('html').getAttribute('lang')
let localeSwal
let localeThumb
window.customInCart = {}

import(`../locale/${lang}`).then((module) => {
    localeSwal = module.Swal
    localeThumb = module.Thumb
})

window.quickUpdateSpinner = {
    updatingIds: {},
    updatingTimeouts: {},
    cancelTokens: {},
    initializeSpinners() {
        requestAnimationFrame(() => {
            document.querySelectorAll('r-spinner.is-quick-update').forEach(rSpinner => {
                if (!rSpinner.classList.contains('is-initialized')) {
                    rSpinner.addEventListener('spin', this.spinCallback.bind(this))
                    rSpinner.addEventListener('stop', this.afterChangeCallback.bind(this))
                    rSpinner.addEventListener('changed', this.afterChangeCallback.bind(this))
                    rSpinner.classList.add('is-initialized')
                    rSpinner.lastValue = rSpinner.getParsedValue()
                }
            })
        })
    },
    cancelUpdating(cartId) {
        const quantityCancelToken = this.cancelTokens[cartId]

        if (quantityCancelToken) {
            quantityCancelToken.cancel()
        }

        this.cancelTokens[cartId] = CancelToken.source()
    },
    spinCallback(event) {
        const rSpinner = event.detail.rSpinner
        const cartId = rSpinner.dataset.cartId

        this.updateCartItem(cartId, rSpinner.getParsedValue(), true)

        if (!this.updatingIds[cartId]) {
            return
        }

        this.updatingIds[cartId] = true
        this.cancelUpdating(cartId)
        rEvent.dispatch('Cart.customCancelFetchCart')

        if (this.updatingTimeouts[cartId]) {
            clearTimeout(this.updatingTimeouts[cartId])
        }
    },
    afterChangeCallback(event) {
        const rSpinner = event.detail.rSpinner
        const cartId = rSpinner.dataset.cartId
        const quantity = rSpinner.getParsedValue()
        const isFirstUpdate = !this.updatingIds[cartId]

        if (rSpinner.input._tippy) {
            rSpinner.input._tippy.hide()
        }
        if (rSpinner.previousElementSibling && rSpinner.previousElementSibling._tippy) {
            rSpinner.previousElementSibling._tippy.hide()
        }

        if (quantity == rSpinner.lastValue && quantity == rSpinner.min) {
            window.Eshop.confirm(
                localeSwal.DeleteProduct.title,
                {
                    denyButtonText: localeSwal.DeleteProduct.deny,
                    confirmButtonText: localeSwal.DeleteProduct.confirm
                },
                () => {
                    document.querySelector('.swal2-confirm').classList.add('is-loading')

                    delete this.updatingIds[cartId]
                    this.cancelUpdating(cartId)
                    this.toggleLoading(cartId, false)

                    return client.post(`/remove-item/${cartId}`).then((response) => {
                        window.rEvent.dispatch('Cart.product.removed', response.data)
                        window.rEvent.dispatch('Cart.customFetchCart')

                        this.updateCartItem(cartId, 0)

                        if (rSpinner.previousElementSibling) {
                            Eshop.tippyAlert(rSpinner.previousElementSibling, localeThumb.productRemoved, {
                                theme: 'success'
                            });
                        }
                    })
                }
            )

            return
        }

        this.updateCartItem(cartId, quantity)
        this.toggleLoading(cartId, true)

        this.updatingIds[cartId] = true
        this.cancelUpdating(cartId)

        if (this.updatingTimeouts[cartId]) {
            clearTimeout(this.updatingTimeouts[cartId])
        }

        this.updatingTimeouts[cartId] = setTimeout(() => {
            this.postNewQuantity(cartId, quantity, rSpinner)

            delete this.updatingTimeouts[cartId]
        }, isFirstUpdate ? 0 : 650)

        rSpinner.lastValue = quantity
    },
    postNewQuantity(cartId, quantity, rSpinner) {
        rEvent.dispatch('Cart.customCancelFetchCart')

        client
            .post(`/change-item-quantity/${cartId}`, {
                quantity: quantity
            }, {
                cancelToken: this.cancelTokens[cartId].token,
            })
            .then((response) => {
                const data = response.data

                if (!data.status) {
                    this.postNewQuantityCallback(cartId, 0)

                    Eshop.tippyAlert(rSpinner.input, localeThumb.quantityUpdated.error, {
                        theme: 'error'
                    });

                    return
                }

                this.postNewQuantityCallback(cartId, quantity)

                Eshop.tippyAlert(rSpinner.input, localeThumb.quantityUpdated.success, {
                    theme: 'success'
                });
            })
            .catch((error) => {
                if (!client.isCancel(error)) {
                    this.postNewQuantityCallback(cartId, quantity)

                    Eshop.tippyAlert(rSpinner.input, localeThumb.quantityUpdated.error, {
                        theme: 'error'
                    });
                }
            })
    },
    postNewQuantityCallback(cartId, quantity) {
        if (!this.updatingTimeouts[cartId]) {
            delete this.updatingIds[cartId]

            this.updateCartItem(cartId, quantity)
            this.toggleLoading(cartId, false)

            rEvent.dispatch('Cart.customFetchCart')
        }
    },
    toggleLoading(cartId, bool) {
        document.querySelectorAll(`r-spinner.is-quick-update[data-cart-id="${cartId}"]`).forEach(rSpinner => {
            rSpinner.classList.toggle('is-loading', bool)
        })
    },
    updateCartItem(cartId, quantity, force = false) {
        if (this.updatingIds[cartId] && !force) {
            return
        }

        document.querySelectorAll(`r-spinner.is-quick-update[data-cart-id="${cartId}"]`).forEach(rSpinner => {
            rSpinner.classList.toggle('is-in-cart', quantity > 0)

            if (rSpinner == document.activeElement || rSpinner.contains(document.activeElement)) {
                rSpinner.oldValue = quantity
            } else {
                rSpinner.updateQuantity(quantity, false)
            }

            rSpinner.prevValue = quantity
        })
    },
    afterFetchedCallback(items) {
        document.querySelectorAll(`r-spinner.is-quick-update`).forEach(rSpinner => {
            if (!this.updatingIds[rSpinner.dataset.cartId]) {
                rSpinner.classList.remove('is-in-cart')
            }
        })

        for (const cartId in items) {
            this.updateCartItem(cartId, items[cartId].quantity)
        }
    }
}

window.initializeSpinners = () => {
    quickUpdateSpinner.initializeSpinners()
}

window.initializeSpinners()

rEvent.on('Listing.fetchedData', () => {
    window.initializeSpinners()
})

rEvent.on('Cart.product.before_add', function (form) {
    const button = form.querySelector('[type="submit"]')

    if (button.removeClassTimeout) {
        clearTimeout(button.removeClassTimeout)
    }

    button.classList.remove('is-loaded')
    button.classList.remove('has-error')
    button.classList.add('is-loading')
    button.disabled = true
})

rEvent.on('Cart.product.after_add', function (response) {
    if (!response || !response.status) {
        return
    }

    window.customInCart[response.item.id] = response.item.quantity
    quickUpdateSpinner.updateCartItem(response.item.id, response.item.quantity)
})

rEvent.on('Cart.addedProduct', function (data) {
    const { response } = data

    window.customInCart[response.item.id] = response.item.quantity
})

rEvent.on('Custom.Cart.addedItem', function (data) {
    const { form, response } = data

    const button = form.querySelector('[type="submit"]')

    if (!response.status) {
        button.classList.add('has-error')
    }

    button.classList.add('is-loaded')
    button.classList.remove('is-loading')
    button.disabled = false

    button.removeClassTimeout = setTimeout(() => {
        button.classList.remove('is-loaded')
        button.removeClassTimeout = false
    }, 1000)

    if (response.item) {
        window.customInCart[response.item.id] = response.item.quantity
    }
})

rEvent.on('Cart.product.removed', function (data) {
    if (!data || !data.response || !data.response.status) {
        return
    }

    delete window.customInCart[data.item.id]
    quickUpdateSpinner.updateCartItem(data.response.item.id, 0)
})

rEvent.on('Cart.fetchedProducts', function (data) {
    if (!data) {
        return
    }

    const response = data.response

    if (!response || !response.status || !response.data) {
        return
    }

    window.customInCart = {}
    for (const cartId in response.data.items) {
        window.customInCart[cartId] = response.data.items[cartId].quantity
    }

    quickUpdateSpinner.afterFetchedCallback(response.data.items)
})

Cart.callbacks.addedItem = function (form, response) {
    if (!response.status) {
        Eshop.tippyAlert(form, response.message, {
            theme: 'error'
        });
        Eshop.preloader.hide();

        Cart.customCallbacks.addedItem(form, response);

        return;
    }

    var $product = $('.cart__product[data-id="' + response.item.id + '"]');

    $('.cart').replaceWith(response.cart);

    if (response.upsell.active && !$('#up-sell').is(':visible')) {
        $.get(response.upsell.url, {
            quantity: response.item.added_quantity
        }, function (html) {
            $('#up-sell').remove();
            $('body').append(html);
            $('#up-sell').modal();
            Eshop.preloader.hide();
            rEvent.dispatch('Cart.upsell.show');
        }, 'html');
    } else {
        let elementToAlert = form;

        if (form.nextElementSibling && form.nextElementSibling.input) {
            elementToAlert = form.nextElementSibling.input
        }

        Eshop.tippyAlert(elementToAlert, response.message, {
            theme: 'success'
        });
        Eshop.preloader.hide();
    }

    if (response.item) {
        Cart.updates.product($product, response.item);
    }

    if (response.totals) {
        Cart.updates.totals(response.totals);
    }

    if (response.free_shipping) {
        Cart.updates.freeShipping(response.free_shipping);
    }

    if (typeof RshopApp !== 'undefined' && RshopApp._isMounted) {
        store.dispatch('fetchCart');
    }

    Cart.storeItems();
    Cart.customCallbacks.addedItem(form, response);
}
